<template>
  <div id="header_report" 
      :style="{
				'background': colors.theme == 'dark' ? '#051520':'#f0f0f0',
				'color': colors.theme == 'dark' ? '#fff' : '#000',
        'border-bottom': colors.theme == 'dark' ? '1px solid #364149' : '1px solid #ccc'
			}">
    <!-- <div class="back" :class="{'gunmetal-bg':!backOption}" @click="backToRoute()">
            <div class="back_icon" v-if="backOption"></div>
            <span class="back_to" v-if="backOption">{{backTo}}</span>
        </div>
        <div class="title">{{title}}</div>
    <div class="logout" @click="logout">sair</div>-->
    <div class="header_report_content"
    :style="{'color': colors.theme == 'dark' ? '#fff' : '#000'}">
      <div class="page_indicator">{{pageNumberIndicator}}/4</div>
      <div class="page_title">{{title}}</div>
      <div class="logout" @click="logout">
        <span
        :style="{
            'color': colors.theme == 'dark' ? '#fff' : '#000',
            'border': colors.theme == 'dark' ? '1px solid #fff' : '1px solid #000'
          }"
        >{{ $t("components.ReportHedaer.logout") }}</span>
      </div>
    </div>
    <page-indicator-bullets :pageNumberIndicator="pageNumberIndicator"></page-indicator-bullets>
  </div>
</template>

<script>
import PageIndicatorBullets from "./PageIndicatorBullets";
export default {
  name: "Header",
  props: {
    backOption: Boolean,
    backTo: String,
    backRoute: String,
    title: String,
    pageNumberIndicator: Number
  },
  data() {
    return {
      colors: {}
    };
  },
  components: {
    "page-indicator-bullets": PageIndicatorBullets
  },
  created() {
    this.colors = JSON.parse(localStorage.getItem("colors"));
    // console.log("pageNumberIndicator Header: ", this.pageNumberIndicator);
  },
  methods: {
    logout() {
      let self = this;
      this.$swal({
        title: this.$t("components.ReportHedaer.swal.title"),
        text: this.$t("components.ReportHedaer.swal.text"),
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          self.$router.push("/logout");
        } else {
          return;
        }
      });
    },
    backToRoute() {
      this.$router.push(`${this.backRoute}`);
    }
  }
};
</script>


<style lang="scss" scoped>
#header_report {
  // height: 10vh;
  background-color: #02f0e4;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 7px;
  width: 100%;

  .header_report_content {
    display: flex;
    width: 100%;
    justify-content: space-around;
    align-items: center;
    letter-spacing: 2px;
    text-transform: uppercase;
    margin: 11px 0 0 0;
    color: #fff;

    .page_indicator {
      width: 20%;
      font-weight: 700;
      font-size: 16px;
    }
    .page_title {
      font-weight: 700;
    }
    .back,
    .logout {
      width: 20%;
      font-size: 10px;
      text-align: end;
    }
  }
  .logout span{
    // border: 1px solid #fff;
    padding: 5px 16px;
    border-radius: 300px;    
  }

  .back_icon {
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid #fff;
    width: 10%;
  }

  .back {
    color: #fff;

    .back_to {
      padding: 0 5px;
      word-wrap: break-word;
      width: 50%;
    }
  }
  .logout {
    // color: #fff;
    font-weight: 900;
  }

  .title {
    color: #02f0e4;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 17px;
    letter-spacing: 6px;
    text-transform: uppercase;
    font-weight: bold;
  }
}

@media only screen and (max-width: 600px) {
  #header_report {
    .back,
    .logout {
      font-size: 14px;

      .back_icon {
        width: 0;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;
        border-right: 10px solid #fff;
        margin-right: 5px;
      }

      .back_to {
        width: 60%;
      }
    }

    .title {
      font-size: 20px;
    }
  }
}
@media only screen and (max-width: 500px) {
  #header_report {
    .back,
    .logout {
      .back_to {
        font-size: 12px;
      }
    }

    .title {
      font-size: 15px;
    }
  }
}
@media only screen and (max-width: 430px) {
  #header_report {
    .back,
    .logout {
      .back_to {
        font-size: 9px;
      }
    }
  }
}
@media only screen and (max-width: 360px) {
  #header_report {
    .back,
    .logout {
      font-size: 12px;

      .back_icon {
        border-top: 5px solid transparent;
        border-bottom: 5px solid transparent;
        border-right: 5px solid #fff;
        margin-right: 5px;
      }

      .back_to {
        font-size: 6px;
      }
    }

    .title {
      font-size: 14px;
    }
  }
}
</style>

